import { routes } from '../config/api_routes'

export const faqCategoryService = {

    getFaqCategoryList: (formData) => {    
        return window.axios.post(routes.getFaqCategoryListApi,formData)
    },

    addFaqCategory: (formData) => {
        return window.axios.post(routes.addFaqCategoryApi,formData)
    },

    getFaqCategoryById: (formData) => {
        return window.axios.post(routes.getFaqCategoryByIdApi,formData)
    },

    updateFaqCategory: (formData) => {
        return window.axios.post(routes.updateFaqCategoryApi,formData)
    },

    deleteFaqCategoryById: (formData) => {
        return window.axios.post(routes.deleteFaqCategoryApi,formData)
    },
    
    updateFaqCategoryOrder: (formData) => {
        return window.axios.post(routes.updateFaqCategoryOrderApi,formData)
    },
    
    getAllFaqCategory: (formData) => {
        return window.axios.post(routes.getAllFaqCategoryApi,formData)
    },
}